"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ImplHelper = void 0;
const NATIVE_RTC = __importStar(require("@iris/native-rtc"));
const BaseType_1 = require("../base/BaseType");
const IrisClientManager_1 = require("../engine/IrisClientManager");
const IrisClientObserver_1 = require("../engine/IrisClientObserver");
const IrisTrackEventHandler_1 = require("../event_handler/IrisTrackEventHandler");
const util_1 = require("../util");
class ImplHelper {
    constructor(engine) {
        this._engine = engine;
    }
    createBufferSourceAudioTrack(soundId, bufferSourceAudioTrackInitConfig) {
        return __awaiter(this, void 0, void 0, function* () {
            let bufferSourceAudioTrack = undefined;
            try {
                bufferSourceAudioTrack = yield this._engine.globalState.AgoraRTC.createBufferSourceAudioTrack(bufferSourceAudioTrackInitConfig);
            }
            catch (e) {
                util_1.AgoraConsole.error('createBufferSourceAudioTrack failed');
                throw e;
            }
            if (bufferSourceAudioTrack) {
                yield this.processAudioTrack(bufferSourceAudioTrack);
            }
            let bufferSourceAudioTrackPackage = new IrisClientManager_1.BufferSourceAudioTrackPackage(BaseType_1.IrisAudioSourceType.kAudioSourceTypeBufferSourceAudio, bufferSourceAudioTrack, soundId);
            this._engine.irisClientManager.addLocalAudioTrackPackage(bufferSourceAudioTrackPackage);
            let trackEventHandler = new IrisTrackEventHandler_1.IrisTrackEventHandler({
                track: bufferSourceAudioTrack,
                trackType: 'IBufferSourceAudioTrack',
            }, this._engine);
            this._engine.irisClientManager.addTrackEventHandler(trackEventHandler);
            return bufferSourceAudioTrackPackage;
        });
    }
    createCustomVideoTrack(videoType, mediaStreamTrack) {
        return __awaiter(this, void 0, void 0, function* () {
            let videoTrackPackage = this._engine.irisClientManager.getLocalVideoTrackPackageBySourceType(videoType)[0];
            let videoTrack;
            let config = {
                mediaStreamTrack,
            };
            //如果已经有track了，就不需要再创建了
            if (videoTrackPackage === null || videoTrackPackage === void 0 ? void 0 : videoTrackPackage.track) {
                return videoTrackPackage;
            }
            //如果没有track，但是有package，就需要创建track
            try {
                videoTrack = this._engine.globalState.AgoraRTC.createCustomVideoTrack(config);
            }
            catch (e) {
                util_1.AgoraConsole.error('createCustomVideoTrack failed');
                throw e;
            }
            yield this.processVideoTrack(videoTrack);
            if (!videoTrackPackage) {
                videoTrackPackage = new IrisClientManager_1.VideoTrackPackage(undefined, undefined, videoType, videoTrack);
                this._engine.irisClientManager.addLocalVideoTrackPackage(videoTrackPackage);
            }
            else {
                videoTrackPackage.track = videoTrack;
            }
            let trackEventHandler = new IrisTrackEventHandler_1.IrisTrackEventHandler({
                track: videoTrack,
                trackType: 'ILocalVideoTrack',
            }, this._engine);
            this._engine.irisClientManager.addTrackEventHandler(trackEventHandler);
            return videoTrackPackage;
        });
    }
    createScreenTrack(captureParams, videoType) {
        return __awaiter(this, void 0, void 0, function* () {
            let videoTrackPackage = this._engine.irisClientManager.getLocalVideoTrackPackageBySourceType(videoType)[0];
            //如果已经有track了，就不需要再创建了
            if (videoTrackPackage === null || videoTrackPackage === void 0 ? void 0 : videoTrackPackage.track) {
                return;
            }
            //如果没有track，但是有package，就需要创建track
            let audioTrack;
            let videoTrack;
            let screenTrack = new Array(2);
            try {
                let conf = this.generateScreenVideoTrackInitConfig();
                let result = yield this._engine.globalState.AgoraRTC.createScreenVideoTrack(conf, captureParams.captureAudio ? 'auto' : 'disable');
                if (Array.isArray(result)) {
                    screenTrack = result;
                }
                else {
                    screenTrack = [result, undefined];
                }
                if (screenTrack) {
                    //每一个track都可能是null
                    audioTrack = screenTrack[1];
                    if (audioTrack) {
                        yield this.processScreenShareAudioTrack(audioTrack);
                        let audioTrackPackage = new IrisClientManager_1.AudioTrackPackage(BaseType_1.IrisAudioSourceType.kAudioSourceTypeScreenCapture, audioTrack);
                        this._engine.irisClientManager.addLocalAudioTrackPackage(audioTrackPackage);
                    }
                    videoTrack = screenTrack[0];
                    if (videoTrack) {
                        yield this.processScreenShareVideoTrack(videoTrack);
                        if (!videoTrackPackage) {
                            videoTrackPackage = new IrisClientManager_1.VideoTrackPackage(undefined, undefined, videoType, videoTrack);
                            this._engine.irisClientManager.addLocalVideoTrackPackage(videoTrackPackage);
                        }
                        else {
                            videoTrackPackage.track = videoTrack;
                        }
                        //设置屏幕共享特殊的事件
                        let trackEventHandler = new IrisTrackEventHandler_1.IrisTrackEventHandler({
                            track: videoTrack,
                            videoSourceType: videoType,
                            trackType: 'ILocalTrack',
                        }, this._engine);
                        this._engine.irisClientManager.addTrackEventHandler(trackEventHandler);
                    }
                }
            }
            catch (e) {
                throw e;
            }
        });
    }
    createMicrophoneAudioTrack() {
        return __awaiter(this, void 0, void 0, function* () {
            let audioTrack;
            try {
                audioTrack = yield this._engine.globalState.AgoraRTC.createMicrophoneAudioTrack();
                yield this._engine.trackHelper.setEnabled(audioTrack, false);
            }
            catch (e) {
                util_1.AgoraConsole.error('createMicrophoneAudioTrack failed');
                throw e;
            }
            yield this.processAudioTrack(audioTrack);
            return audioTrack;
        });
    }
    createVideoCameraTrack() {
        return __awaiter(this, void 0, void 0, function* () {
            let videoTrack;
            try {
                videoTrack = yield this._engine.globalState.AgoraRTC.createCameraVideoTrack();
                yield this._engine.trackHelper.setEnabled(videoTrack, false);
            }
            catch (e) {
                util_1.AgoraConsole.error('createCameraVideoTrack failed');
                throw e;
            }
            yield this.processVideoTrack(videoTrack);
            return videoTrack;
        });
    }
    //当一个audioTrack被创建的时候，要拆解这些参数
    processScreenShareAudioTrack(audioTrack) {
        return __awaiter(this, void 0, void 0, function* () {
            let globalState = this._engine.globalState;
            if (globalState.pausedAudio) {
                yield this._engine.trackHelper.setEnabled(audioTrack, false);
            }
            if (globalState.mutedLocalAudioStream) {
                yield this._engine.trackHelper.setMuted(audioTrack, true);
            }
        });
    }
    processScreenShareVideoTrack(videoTrack) {
        return __awaiter(this, void 0, void 0, function* () {
            let globalState = this._engine.globalState;
            if (globalState.pausedVideo) {
                yield this._engine.trackHelper.setEnabled(videoTrack, false);
            }
            if (globalState.mutedLocalVideoStream) {
                yield this._engine.trackHelper.setMuted(videoTrack, true);
            }
        });
    }
    processAudioTrack(audioTrack) {
        return __awaiter(this, void 0, void 0, function* () {
            let globalState = this._engine.globalState;
            if (globalState.pausedAudio) {
                yield this._engine.trackHelper.setEnabled(audioTrack, false);
            }
            if (globalState.mutedLocalAudioStream) {
                yield this._engine.trackHelper.setMuted(audioTrack, true);
            }
        });
    }
    processVideoTrack(videoTrack) {
        return __awaiter(this, void 0, void 0, function* () {
            let globalState = this._engine.globalState;
            if (globalState.pausedVideo) {
                yield this._engine.trackHelper.setEnabled(videoTrack, false);
            }
            if (globalState.mutedLocalVideoStream) {
                yield this._engine.trackHelper.setMuted(videoTrack, true);
            }
        });
    }
    generateScreenVideoTrackInitConfig() {
        let videoConfig = {};
        let conf = {};
        let globalState = this._engine.globalState;
        if (globalState.screenCaptureContentHint != null &&
            globalState.screenCaptureContentHint !=
                NATIVE_RTC.VIDEO_CONTENT_HINT.CONTENT_HINT_NONE) {
            conf.optimizationMode = util_1.AgoraTranslate.NATIVE_RTCVIDEO_CONTENT_HINT2string(globalState.screenCaptureContentHint);
        }
        if (globalState.screenCaptureParameters2 != null) {
            conf.encoderConfig = util_1.AgoraTranslate.NATIVE_RTCScreenCaptureParameters2VideoEncoderConfiguration(globalState.screenCaptureParameters2);
        }
        return conf;
    }
    enumerateDevices() {
        return __awaiter(this, void 0, void 0, function* () {
            let info = yield this._engine.globalState.AgoraRTC.getDevices();
            let playbackDevices = [];
            let recordingDevices = [];
            let videoDevices = [];
            for (let e of info) {
                if (e.kind == 'audiooutput') {
                    playbackDevices.push({
                        deviceId: e.deviceId,
                        deviceName: e.label,
                    });
                }
                else if (e.kind == 'audioinput') {
                    recordingDevices.push({
                        deviceId: e.deviceId,
                        deviceName: e.label,
                    });
                }
                else if (e.kind == 'videoinput') {
                    videoDevices.push({
                        deviceId: e.deviceId,
                        deviceName: e.label,
                    });
                }
            }
            this._engine.globalState.playbackDevices = playbackDevices;
            this._engine.globalState.recordingDevices = recordingDevices;
            this._engine.globalState.videoDevices = videoDevices;
            return {
                playbackDevices: playbackDevices,
                recordingDevices: recordingDevices,
                videoDevices: videoDevices,
            };
        });
    }
    updateChannelMediaOptions(options, connection) {
        return __awaiter(this, void 0, void 0, function* () {
            // AUDIT-v18: normalizzazione publishScreenCaptureVideo → publishScreenTrack
            // centralizzata in util/normalizeMediaOptions.
            (0, util_1.normalizeMediaOptions)(options);
            const irisClientManager = this._engine.irisClientManager;
            let irisClient;
            if (connection) {
                irisClient = irisClientManager.getIrisClientByConnection(connection);
            }
            else {
                irisClient = irisClientManager.getIrisClient();
            }
            if (!irisClient) {
                return;
            }
            let irisClientState = irisClient.irisClientState;
            let agoraRTCClient = irisClient.agoraRTCClient;
            let irisClientObserver = irisClientManager.irisClientObserver;
            let localAudioTrackPackages = irisClientManager.localAudioTrackPackages;
            let localVideoTrackPackages = irisClientManager.localVideoTrackPackages;
            if (connection) {
                localAudioTrackPackages = irisClientManager.getLocalAudioTrackPackageByConnection(connection);
                localVideoTrackPackages = irisClientManager.getLocalVideoTrackPackageByConnection(connection);
            }
            //clientRole update
            if ((0, util_1.isDefined)(options.clientRoleType)) {
                if (options.clientRoleType ===
                    NATIVE_RTC.CLIENT_ROLE_TYPE.CLIENT_ROLE_AUDIENCE &&
                    irisClientState.clientRoleType !== options.clientRoleType) {
                    this._engine.getImplInstance('RtcEngine').muteLocalAudioStream_5039d15(true);
                    this._engine.getImplInstance('RtcEngine').muteLocalVideoStream_5039d15(true);
                    this._engine.rtcEngineEventHandler.onClientRoleChanged_2acaf10(irisClient.connection, irisClientState.clientRoleType, options.clientRoleType, options);
                }
                if (agoraRTCClient) {
                    yield this._engine.clientHelper.setClientRole(agoraRTCClient, options.clientRoleType, irisClientState.audienceLatencyLevel);
                }
                irisClientState.clientRoleType = options.clientRoleType;
            }
            //token update
            if ((0, util_1.isDefined)(options.token)) {
                // AUDIT-v18: guard su agoraRTCClient mancante. Pre-join il client non
                // esiste, renewToken era undefined → null pointer. Salviamo comunque
                // il token nello state, così verrà usato al join successivo.
                if (!agoraRTCClient) {
                    irisClientState.token = options.token;
                }
                else {
                    try {
                        yield agoraRTCClient.renewToken(options.token);
                    }
                    catch (e) {
                        util_1.AgoraConsole.error(`renewToken failed: ${e}`);
                        return this._engine.returnResult(false);
                    }
                }
            }
            let needPublishVideoTrackPackages = [];
            let needUnPublishVideoTrackPackages = [];
            let needPublishAudioTrackPackages = [];
            let needUnPublishAudioTrackPackages = [];
            if (irisClientState.clientRoleType ===
                NATIVE_RTC.CLIENT_ROLE_TYPE.CLIENT_ROLE_BROADCASTER) {
                if (options.publishCameraTrack === false) {
                    needUnPublishVideoTrackPackages = [
                        ...needUnPublishVideoTrackPackages,
                        ...localVideoTrackPackages.filter((e) => e.type ===
                            NATIVE_RTC.VIDEO_SOURCE_TYPE.VIDEO_SOURCE_CAMERA_PRIMARY),
                    ];
                }
                if (options.publishCameraTrack === true) {
                    needPublishVideoTrackPackages = [
                        ...needPublishVideoTrackPackages,
                        ...localVideoTrackPackages.filter((e) => e.type ===
                            NATIVE_RTC.VIDEO_SOURCE_TYPE.VIDEO_SOURCE_CAMERA_PRIMARY),
                    ];
                }
                if (options.publishMicrophoneTrack === false) {
                    needUnPublishAudioTrackPackages = [
                        ...needUnPublishAudioTrackPackages,
                        ...localAudioTrackPackages.filter((e) => e.type === BaseType_1.IrisAudioSourceType.kAudioSourceTypeMicrophonePrimary),
                    ];
                }
                if (options.publishMicrophoneTrack === true) {
                    needPublishAudioTrackPackages = [
                        ...needPublishAudioTrackPackages,
                        ...localAudioTrackPackages.filter((e) => e.type === BaseType_1.IrisAudioSourceType.kAudioSourceTypeMicrophonePrimary),
                    ];
                }
                if (options.publishScreenTrack === false) {
                    needUnPublishAudioTrackPackages = [
                        ...needUnPublishAudioTrackPackages,
                        ...localAudioTrackPackages.filter((e) => e.type === BaseType_1.IrisAudioSourceType.kAudioSourceTypeScreenCapture),
                    ];
                    needUnPublishVideoTrackPackages = [
                        ...needUnPublishVideoTrackPackages,
                        ...localVideoTrackPackages.filter((e) => e.type ===
                            NATIVE_RTC.VIDEO_SOURCE_TYPE.VIDEO_SOURCE_SCREEN_PRIMARY),
                    ];
                }
                if (options.publishScreenTrack === true) {
                    needPublishAudioTrackPackages = [
                        ...needPublishAudioTrackPackages,
                        ...irisClientManager.localAudioTrackPackages.filter((e) => e.type === BaseType_1.IrisAudioSourceType.kAudioSourceTypeScreenCapture),
                    ];
                    needPublishVideoTrackPackages = [
                        ...needPublishVideoTrackPackages,
                        ...irisClientManager.localVideoTrackPackages.filter((e) => e.type ===
                            NATIVE_RTC.VIDEO_SOURCE_TYPE.VIDEO_SOURCE_SCREEN_PRIMARY),
                    ];
                }
                irisClientState.mergeChannelMediaOptions(options);
                yield irisClientObserver.notifyLocal(IrisClientObserver_1.NotifyType.UNPUBLISH_TRACK, [
                    ...needUnPublishAudioTrackPackages,
                    ...needUnPublishVideoTrackPackages,
                ], [irisClient]);
                yield irisClientObserver.notifyLocal(IrisClientObserver_1.NotifyType.PUBLISH_TRACK, [...needPublishVideoTrackPackages, ...needPublishAudioTrackPackages], [irisClient]);
            }
        });
    }
    joinChannel(token, channelId, uid, options) {
        return __awaiter(this, void 0, void 0, function* () {
            var _a;
            let globalState = this._engine.globalState;
            let irisClient = this._engine.irisClientManager.getIrisClient();
            irisClient.createClient(options);
            options = irisClient.irisClientState;
            irisClient.irisClientState.token = token;
            if (!irisClient.agoraRTCClient) {
                return this._engine.returnResult(false);
            }
            let agoraRTCClient = irisClient.agoraRTCClient;
            try {
                yield agoraRTCClient.join(globalState.rtcEngineContext.appId, channelId, token ? token : null, uid);
            }
            catch (reason) {
                util_1.AgoraConsole.error(reason);
                this._engine.rtcEngineEventHandler.onError_d26c0fd(NATIVE_RTC.ERROR_CODE_TYPE.ERR_JOIN_CHANNEL_REJECTED, '');
                // AUDIT-v18: await release — evita orphan state in irisClientList
                // se caller rilancia joinChannel dopo fallimento.
                try {
                    yield irisClient.release();
                }
                catch (_b) { }
                return this._engine.returnResult(false);
            }
            let con = {
                channelId: channelId,
                localUid: agoraRTCClient.uid,
            };
            //@ts-ignore websdk的私有属性
            //如果是string uid 登录
            if (agoraRTCClient.isStringUID) {
                //@ts-ignore
                con.localUid = (_a = agoraRTCClient._joinInfo) === null || _a === void 0 ? void 0 : _a.uid;
                this._engine.irisClientManager.addUserInfo({
                    uid: con.localUid,
                    userAccount: uid,
                });
            }
            irisClient.connection = con;
            this._engine.rtcEngineEventHandler.onJoinChannelSuccess_263e4cd(con, 0);
            if (irisClient.irisClientState.clientRoleType ===
                NATIVE_RTC.CLIENT_ROLE_TYPE.CLIENT_ROLE_BROADCASTER &&
                this._engine.globalState.enabledAudio &&
                options.publishMicrophoneTrack) {
                if (!this._engine.irisClientManager.getLocalAudioTrackPackageBySourceType(BaseType_1.IrisAudioSourceType.kAudioSourceTypeMicrophonePrimary)[0]) {
                    let audioTrack = yield this._engine.implHelper.createMicrophoneAudioTrack();
                    this._engine.irisClientManager.addLocalAudioTrackPackage(new IrisClientManager_1.AudioTrackPackage(BaseType_1.IrisAudioSourceType.kAudioSourceTypeMicrophonePrimary, audioTrack));
                    yield this._engine.trackHelper.setEnabled(audioTrack, true);
                }
            }
            yield this._engine.irisClientManager.irisClientObserver.notifyLocal(IrisClientObserver_1.NotifyType.PUBLISH_TRACK, [
                ...this._engine.irisClientManager.localAudioTrackPackages,
                ...this._engine.irisClientManager.localVideoTrackPackages,
            ], [irisClient]);
        });
    }
    isScreenCapture(sourceType) {
        return (sourceType == NATIVE_RTC.VIDEO_SOURCE_TYPE.VIDEO_SOURCE_SCREEN_PRIMARY ||
            sourceType ==
                NATIVE_RTC.VIDEO_SOURCE_TYPE.VIDEO_SOURCE_SCREEN_SECONDARY ||
            sourceType == NATIVE_RTC.VIDEO_SOURCE_TYPE.VIDEO_SOURCE_SCREEN_THIRD ||
            sourceType == NATIVE_RTC.VIDEO_SOURCE_TYPE.VIDEO_SOURCE_SCREEN_FOURTH);
    }
    isVideoCamera(sourceType) {
        return (sourceType == NATIVE_RTC.VIDEO_SOURCE_TYPE.VIDEO_SOURCE_CAMERA_PRIMARY ||
            sourceType ==
                NATIVE_RTC.VIDEO_SOURCE_TYPE.VIDEO_SOURCE_CAMERA_SECONDARY ||
            sourceType == NATIVE_RTC.VIDEO_SOURCE_TYPE.VIDEO_SOURCE_CAMERA_THIRD ||
            sourceType == NATIVE_RTC.VIDEO_SOURCE_TYPE.VIDEO_SOURCE_CAMERA_FOURTH);
    }
    isAudio(sourceType) {
        return (sourceType === BaseType_1.IrisAudioSourceType.kAudioSourceTypeMicrophonePrimary ||
            sourceType === BaseType_1.IrisAudioSourceType.kAudioSourceTypeMicrophoneSecondary ||
            sourceType === BaseType_1.IrisAudioSourceType.kAudioSourceTypeScreenCapture ||
            sourceType === BaseType_1.IrisAudioSourceType.kAudioSourceTypeCustom ||
            sourceType === BaseType_1.IrisAudioSourceType.kAudioSourceTypeUnknown);
    }
}
exports.ImplHelper = ImplHelper;
